/**
 * First-party submit-funnel telemetry.
 *
 * lead_backups.form_submissions only sees submissions that reach the backend,
 * so a submit that dies in the browser (JS error, network failure, blocked
 * request) is indistinguishable from an abandon. These events close that gap:
 * attempt fires right before the POST to /api/lead-submit, success/error fire
 * on its outcome, and beacon fires for the unload-time auto-submit path whose
 * outcome the page can never observe.
 *
 * Fire-and-forget by construction: navigator.sendBeacon (keepalive fetch as
 * fallback), same-origin /api/form-telemetry, everything wrapped in try/catch
 * so telemetry can never slow down or break a submission. Rows land in
 * cabana-cac.lead_backups.form_telemetry via the lead-processor /telemetry
 * endpoint; join to form_submissions on contact_id / ga_session_id.
 */
import brandConfig from '../config/brand';

export function trackSubmitTelemetry(event, fields = {}) {
  try {
    const payload = JSON.stringify({
      event,
      page: window.location.pathname,
      site_origin: brandConfig.siteOrigin,
      ga_session_id: localStorage.getItem('ga_session_id') || undefined,
      utm_source: localStorage.getItem('utm_source') || undefined,
      ...fields,
    });
    const url = '/api/form-telemetry';
    if (typeof navigator !== 'undefined' && navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([payload], { type: 'application/json' }));
    } else if (typeof window !== 'undefined' && window.fetch) {
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: payload,
        keepalive: true,
      }).catch(() => {});
    }
  } catch (_e) {
    // Telemetry must never interfere with the form.
  }
}
